import styled from 'styled-components';
import { Checkbox, Form, Input } from 'antd';

import {
  FormContentStyles,
  InputFocusStyles,
  InputFontStyles,
  InputPadding,
  InputSize,
  InputStyles,
  PRIMARY_TEXT_COLOUR,
} from 'theme';
import { StyledInput } from 'components';
import { TERMS_URL } from 'const';

const Wrapper = styled.div<{ visible: boolean }>`
  display: ${(props) => (props.visible ? 'block' : 'none')};
  ${FormContentStyles}
`;
const INPUT_SPACING = '35px';
const SpacedInput = styled(StyledInput)`
  margin-top: ${INPUT_SPACING};
`;

const FirstRow = styled.div`
  display: flex;
`;

const PasswordInput = styled(Input.Password)`
  margin-top: ${INPUT_SPACING};
  ${InputStyles};
  ${InputFocusStyles};
  ${InputSize};
  ${InputPadding};

  && .ant-input {
    ${InputFontStyles};
  }
`;
const StyledFormItem = styled(Form.Item)`
  margin: 0;

  .ant-form-item-explain {
    height: 0 !important;
    font-size: 12px !important;
    font-weight: 500;
    line-height: normal;
  }

  .ant-form-item-explain > div {
    padding-left: 2px !important;
    padding-top: 4px !important;
  }
`;
const SpacedFormItem = styled(StyledFormItem)`
  margin-right: 16px;
`;

const ConfirmationBox = styled(Checkbox)`
  margin-top: 36px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;

  span.ant-checkbox-inner && {
    height: 20px;
    width: 20px;
    border-width: 2px !important;
  }
`;

const Link = styled.a`
  color: ${PRIMARY_TEXT_COLOUR};
  text-decoration: underline;
`;

export const SIGNUP_FIELDS = ['FirstName', 'LastName', 'BusinessName', 'Email', 'Password', 'Confirmed'];

export const OnboardingSignup = ({ visible }: { visible: boolean }) => {
  return (
    <Wrapper visible={visible}>
      <FirstRow>
        <SpacedFormItem name="FirstName">
          <StyledInput placeholder="First Name" />
        </SpacedFormItem>
        <StyledFormItem name="LastName">
          <StyledInput placeholder="Last Name" />
        </StyledFormItem>
      </FirstRow>
      <StyledFormItem name="BusinessName">
        <SpacedInput placeholder="Business Name" />
      </StyledFormItem>
      <StyledFormItem name="Email">
        <SpacedInput placeholder="Email" type="email" />
      </StyledFormItem>
      <StyledFormItem name="Password" help="Minimum 8 characters, 1 number, 1 special character">
        <PasswordInput type="password" placeholder="Password" />
      </StyledFormItem>
      <StyledFormItem name="Confirmed" valuePropName="checked">
        <ConfirmationBox>
          I confirm I have read the VidApp{' '}
          <Link href={TERMS_URL} target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </Link>
        </ConfirmationBox>
      </StyledFormItem>
    </Wrapper>
  );
};
